"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageSummaryContainer = exports.CustomerSummaryContainer = exports.SimpleVehicleSummaryContainer = exports.VehicleSummaryContainer = exports.TimeslotSummaryContainer = exports.MobilitySummaryContainer = exports.ServiceSummaryContainer = exports.GarageSummaryContainer = undefined;

var _SummaryElement = require("./SummaryElement");

var _SummaryElement2 = _interopRequireDefault(_SummaryElement);

var _index = require("../../components/summary/index");

var _form = require("../../actions/form");

var _reactRedux = require("react-redux");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function mapDispatchToProps(dispatch) {
  return {
    goToStep: function goToStep(stepId) {
      dispatch((0, _form.selectStep)(stepId));
    }
  };
}

var garageProps = function garageProps(state) {
  var formData = state.formData;
  var garages = state.garage.garages;
  var garageId = formData.garageId;
  var garage = garages[garageId];
  return {
    garage: garage
  };
};

var mobilityProps = function mobilityProps(state) {
  var formData = state.formData;
  var garages = state.garage.garages;
  var garageId = formData.garageId;
  var garage = garages[garageId];
  var mobilityId = formData.mobilityId;
  var mobility = {
    Name: "keine Mobilität ausgewählt"
  };

  if (garage) {
    for (var mobilityOption in garage.MobilityOptions) {
      if (garage.MobilityOptions[mobilityOption].Id === mobilityId) {
        mobility = garage.MobilityOptions[mobilityOption];
      }
    }
  }

  return {
    mobility: mobility
  };
};

var serviceProps = function serviceProps(state) {
  var service = state.service,
      formData = state.formData;
  var serviceIds = formData.serviceIds;
  var services = service.services;
  services = serviceIds.map(function (serviceId) {
    return services[serviceId];
  });
  return {
    services: services,
    formData: formData
  };
};

var timeslotProps = function timeslotProps(state) {
  var formData = state.formData;
  var day = formData.day,
      hour = formData.hour,
      minute = formData.minute;
  return {
    day: day,
    hour: hour,
    minute: minute
  };
};

var vehicleProps = function vehicleProps(state) {
  var formData = state.formData,
      vehicleSelection = state.vehicleSelection;
  var mileage = formData.mileage,
      registerDate = formData.registerDate,
      licensePlate = formData.licensePlate,
      fin = formData.fin;
  var brand = vehicleSelection.brand,
      model = vehicleSelection.model,
      type = vehicleSelection.type;
  return {
    brand: brand,
    model: model,
    type: type,
    mileage: mileage,
    registerDate: registerDate,
    licensePlate: licensePlate,
    fin: fin
  };
};

var simpleVehicleProps = function simpleVehicleProps(state) {
  var formData = state.formData;
  var mileage = formData.mileage,
      licensePlate = formData.licensePlate,
      fin = formData.fin;
  return {
    mileage: mileage,
    licensePlate: licensePlate,
    fin: fin
  };
};

var customerProps = function customerProps(state) {
  var formData = state.formData;
  var firstName = formData.firstName,
      lastName = formData.lastName,
      company = formData.company,
      email = formData.email,
      phone = formData.phone;
  return {
    firstName: firstName,
    lastName: lastName,
    company: company,
    email: email,
    phone: phone
  };
};

var messageProps = function messageProps(state) {
  var formData = state.formData;
  var message = formData.message;
  return {
    message: message
  };
};

var GarageSummaryContainer = (0, _reactRedux.connect)(garageProps, mapDispatchToProps)((0, _SummaryElement2.default)(_index.GarageSummaryElement, "garage"));
var MobilitySummaryContainer = (0, _reactRedux.connect)(mobilityProps, mapDispatchToProps)((0, _SummaryElement2.default)(_index.MobilitySummaryElement, "mobility"));
var ServiceSummaryContainer = (0, _reactRedux.connect)(serviceProps, mapDispatchToProps)((0, _SummaryElement2.default)(_index.ServiceSummaryElement, "service"));
var TimeslotSummaryContainer = (0, _reactRedux.connect)(timeslotProps, mapDispatchToProps)((0, _SummaryElement2.default)(_index.TimeslotSummaryElement, "timeslot"));
var VehicleSummaryContainer = (0, _reactRedux.connect)(vehicleProps, mapDispatchToProps)((0, _SummaryElement2.default)(_index.VehicleSummaryElement, "vehicle"));
var SimpleVehicleSummaryContainer = (0, _reactRedux.connect)(simpleVehicleProps, mapDispatchToProps)((0, _SummaryElement2.default)(_index.SimpleVehicleSummaryElement, "simple-vehicle"));
var CustomerSummaryContainer = (0, _reactRedux.connect)(customerProps, mapDispatchToProps)((0, _SummaryElement2.default)(_index.CustomerSummaryElement, "customer"));
var MessageSummaryContainer = (0, _reactRedux.connect)(messageProps, mapDispatchToProps)((0, _SummaryElement2.default)(_index.CustomerMessageElement, "customer"));
exports.GarageSummaryContainer = GarageSummaryContainer;
exports.ServiceSummaryContainer = ServiceSummaryContainer;
exports.MobilitySummaryContainer = MobilitySummaryContainer;
exports.TimeslotSummaryContainer = TimeslotSummaryContainer;
exports.VehicleSummaryContainer = VehicleSummaryContainer;
exports.SimpleVehicleSummaryContainer = SimpleVehicleSummaryContainer;
exports.CustomerSummaryContainer = CustomerSummaryContainer;
exports.MessageSummaryContainer = MessageSummaryContainer;